function estimateShipping({
  daysOffUnparsed, 
  overNightDatesUnparsed, 
  shippingDateRange, // offsets from current date at lagosHQ [start offset, end offest]
  lagosDate = makeLagosLocalDate(Date.now())
}) {
  const daysOff = parseAdminSettingList(daysOffUnparsed);
  Date.prototype.asAdvanceable = function() {
    return new AdvanceableDate(this, daysOff);
  };
  //advance by shipping date
  const lagosJsDate = jsDateFromLagosDate(lagosDate);
  if (lagosJsDate.getHours() > 14) {
    lagosJsDate.addDays(1).setHours(1);
  }
  const overNightDates = parseAdminSettingList(overNightDatesUnparsed);
  const isOverNight = isOverNightDate(lagosJsDate, overNightDates);
  const start = isOverNight ? 1 : shippingDateRange[0];
  const end = isOverNight ? 2 : shippingDateRange[1];
  lagosJsDate.asAdvanceable().advanceBy(0);
  const fromDate = new Date(lagosJsDate.getTime());
  const toDate = new Date(lagosJsDate.getTime());
  fromDate.asAdvanceable().advanceBy(start)
  toDate.asAdvanceable().advanceBy(start)
  toDate.asAdvanceable().advanceBy(Math.abs(end - start));
  delete Date.prototype.asAdvanceable;
  return { fromDate, toDate };
}

class AdvanceableDate{ 
  constructor(date, daysOff) {
    this.date = date; 
    this.daysOff = daysOff;
  }

  advanceBy(amount) {
    while (amount > 0 || this.isNotValid()) {
      this.date.addDays(1);
      while (this.isNotValid()) {
        this.date.addDays(1);
      }
      amount -= 1;
    }
  }

  isNotValid() {
    const fmtDate = this.date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'numeric', 
      day: 'numeric'
    }).replace(/\//g, ".");
    return this.date.is().saturday()
      || this.date.is().sunday() 
      || this.daysOff.includes(fmtDate);
  }
}

function jsDateFromLagosDate(lagosDate) {
  let { year, month, day, hour, minute } = lagosDate;
  return new Date(year, month - 1, day, hour, minute);
}

function makeLagosLocalDate(day) {
  const dateTime = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hourCycle: "h24",
      timeStyle: "short",
      dateStyle: "short"
    })
    .format(day)
    .toString()
    .split(", ");
  const date = dateTime[0].split("/");
  const time = dateTime[1].split(":");
  return {
    year: parseInt(date[2]) + 2000,
    month: parseInt(date[0]),
    day: parseInt(date[1]),
    hour: parseInt(time[0]),
    minute: parseInt(time[1]),
  };
}

function parseAdminSettingList(list) {
  return list?.split('|')?.map(x => {
    const date = x?.trim()?.split("."); // mm.dd.yy or mm.dd.yyyy
    if (x?.length && date?.length === 3) {
      const year = date[2]?.length === 4 
        ? date[2] 
        : `20${date[2][date[2].length - 2]}${date[2][date[2].length - 1]}`;
      return `${date[0]}.${date[1]}.${year}`;
    } else {
      return x;
    }
  }) || [];
}

function isOverNightDate(lagosDate, overNightDates) {
  const { year, month, day } = makeLagosLocalDate(lagosDate);
  const fmtDate = `${month}.${day}.${year}`;
  return overNightDates.includes(fmtDate) || false;
}

// DETERMINE IF WERE IN TESTING ENV (NODE) OR PROD ENV (BROWSER) 
const isBrowser =() =>
   typeof window !== 'undefined' && typeof document !== 'undefined';

const isNode = () => 
   typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

if (isBrowser()) {
  document.dispatchEvent(new CustomEvent('estimateShippingScriptLoaded'));
} else if (isNode()) {
  const https = require('https');
  const vm = require('vm');
  const datejsUrl = 'https://cdnjs.cloudflare.com/ajax/libs/datejs/1.0/date.min.js';
  function loadAndExecuteScript(url) {
    https.get(url, (res) => {
      if (res.statusCode !== 200) {
        console.error(`Failed to fetch script: ${res.statusMessage}`);
        return res.resume();
      }
      let scriptContent = '';
      res.on('data', (chunk) => {
        scriptContent += chunk;
      });
      res.on('end', () => {
        try {
          const script = new vm.Script(scriptContent);
          const context = vm.createContext(global);
          script.runInContext(context);
          tests();
        } catch (error) {
          console.error('Error executing script:', error);
        }
      });
    }).on('error', (error) => {
        console.error('Error fetching script:', error);
      });
  }
  loadAndExecuteScript(datejsUrl);
} else {
  console.error('Enviroment undetermined');
}

// TESTS
function tests() {

  function assertDate(args) {
    const { name, input, targets, daysOff, overNightDates } = args;
    const range = args.range || [2, 3];
    let { toDate, fromDate } = estimateShipping({
      daysOffUnparsed: daysOff, 
      overNightDatesUnparsed: overNightDates, 
      shippingDateRange: range,
      lagosDate: input
    });
    const inputFrom = fromDate.toString('ddd. MMM d');
    const inputTo = toDate.toString('ddd. MMM d');
    const targetFrom = jsDateFromLagosDate(targets.from).toString('ddd. MMM d');
    const targetTo = jsDateFromLagosDate(targets.to).toString('ddd. MMM d');
    const inBrowswer = isBrowser();
    const style = {
      pass: inBrowswer  ? '%c' : '\x1b[32m',
      fail: inBrowswer  ? '%c' : '\x1b[31m',
      reset: inBrowswer ? '%c' : '\x1b[0m',
    };
    if (inputTo === targetTo && inputFrom === targetFrom) {
      console.log(
        `${name}: ${style.pass}PASS${style.reset}`, 
        inBrowswer ? 'background: #222; color: #bada55' : ''
      );
    } else {
      console.log(
        `${name}: ${style.fail}FAIL${style.reset}
  Input:    ${jsDateFromLagosDate(input).toString('ddd. MMM d')} at ${input.hour}hr with a range of ${range[0]} to ${range[1]} days
  Expected: ${targetFrom} - ${targetTo}
  Got:      ${inputFrom} - ${inputTo}`,
        inBrowswer ? 'background: #222; color: #ff0000' : ''
      );
    }
  }

  const daysOff = "12.25.24|1.1.25|12.17.24";
  const overNightDates =  "12.20.24|11.14.24|11.13.24|1.28.25";

  assertDate({
    name: "Verify testing - SHOULD FAIL", 
    input: {year: 2025, month: 2, day: 1, hour: 13, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 13, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 14, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order before 3 no weekend or days off. range 2-3", 
    input: {year: 2025, month: 2, day: 11, hour: 13, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 13, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 14, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order before 3 no weekend or days off. manual range 1-2", 
    input: {year: 2025, month: 2, day: 11, hour: 13, minute: 0}, 
    range: [1, 2],
    targets: { 
      from: {year: 2025, month: 2, day: 12, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 13, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order after 3 no weekend or days off. range 2-3", 
    input: {year: 2025, month: 2, day: 10, hour: 15, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 13, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 14, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order after 3 into weekend. range 2-3", 
    input: {year: 2025, month: 2, day: 11, hour: 15, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 14, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 17, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order on Saturday. range. 2-3", 
    input: {year: 2025, month: 2, day: 15, hour: 15, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 19, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 20, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order on Sunday. range. 2-3", 
    input: {year: 2025, month: 2, day: 16, hour: 15, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 19, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 20, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order on Friday. range 2-3", 
    input: {year: 2025, month: 2, day: 15, hour: 1, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 19, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 20, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order on Monday with long range. range 5-8", 
    input: {year: 2025, month: 1, day: 15, hour: 1, minute: 0}, 
    range: [5, 8],
    targets: { 
      from: {year: 2025, month: 1, day: 22, hour: 0, minute: 0},
      to: {year: 2025, month: 1, day: 27, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order next day shipping (12.20.24) and weekend. range 2-3", 
    input: {year: 2024, month: 12, day: 20, hour: 1, minute: 0}, 
    targets: { 
      from: {year: 2024, month: 12, day: 23, hour: 0, minute: 0},
      to: {year: 2024, month: 12, day: 24, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order next day shipping (11.14.24) before weekend. range 2-3", 
    input: {year: 2024, month: 11, day: 14, hour: 1, minute: 0}, 
    targets: { 
      from: {year: 2024, month: 11, day: 15, hour: 0, minute: 0},
      to: {year: 2024, month: 11, day: 18, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order next day shipping (11.13.24) on weekday. range 2-3", 
    input: {year: 2024, month: 11, day: 13, hour: 1, minute: 0}, 
    targets: { 
      from: {year: 2024, month: 11, day: 14, hour: 0, minute: 0},
      to: {year: 2024, month: 11, day: 15, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order with next day off (12.17.24) during week. range 2-3", 
    input: {year: 2024, month: 12, day: 16, hour: 11, minute: 0}, 
    targets: { 
      from: {year: 2024, month: 12, day: 19, hour: 0, minute: 0},
      to: {year: 2024, month: 12, day: 20, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order with next day off (12.25.24) into weekend. range 2-3", 
    input: {year: 2024, month: 12, day: 24, hour: 11, minute: 0}, 
    targets: { 
      from: {year: 2024, month: 12, day: 27, hour: 0, minute: 0},
      to: {year: 2024, month: 12, day: 30, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order with day off during arrival window (1.1.25) into weekend. range 2-3", 
    input: {year: 2024, month: 12, day: 30, hour: 15, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 1, day: 3, hour: 0, minute: 0},
      to: {year: 2025, month: 1, day: 6, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Order after 3pm with overnight on next day (1.28.25). range 2-3", 
    input: {year: 2025, month: 1, day: 27, hour: 15, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 1, day: 29, hour: 0, minute: 0},
      to: {year: 2025, month: 1, day: 30, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Inverted range does not crash", 
    input: {year: 2024, month: 12, day: 30, hour: 15, minute: 0}, 
    range: [3, 2],
    targets: { 
      from: {year: 2025, month: 1, day: 6, hour: 0, minute: 0},
      to: {year: 2025, month: 1, day: 7, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Negative range does not crash", 
    input: {year: 2024, month: 12, day: 30, hour: 15, minute: 0}, 
    range: [-1, -2],
    targets: { 
      from: {year: 2024, month: 12, day: 31, hour: 0, minute: 0},
      to: {year: 2025, month: 1, day: 2, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates,
  });

  assertDate({
    name: "Empty days off", 
    input: {year: 2025, month: 2, day: 11, hour: 13, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 13, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 14, hour: 0, minute: 0},
    },
    daysOff: "",
    overNightDates,
  });

  assertDate({
    name: "Empty overnight dates", 
    input: {year: 2025, month: 2, day: 11, hour: 13, minute: 0}, 
    targets: { 
      from: {year: 2025, month: 2, day: 13, hour: 0, minute: 0},
      to: {year: 2025, month: 2, day: 14, hour: 0, minute: 0},
    },
    daysOff,
    overNightDates: "",
  });
}
